import { MdLocationPin } from "react-icons/md";
import { FaGoogle } from "react-icons/fa"; // Import Google icon from react-icons (install if needed: npm i react-icons)

function VerifyCompanyButton({ companyName, address, location, localGovernment, city }) {
  const handleVerifyCompany = () => {
    // Construct the full address string for the search
    const fullAddress = `${companyName} company ${address || location} ${localGovernment} ${city}`.trim();
    
    // Encode the search query for URL safety (handles spaces, special chars)
    const encodedQuery = encodeURIComponent(fullAddress);
    
    // Google Search URL: Searches for the company + address to show location, images, and verification info
    const googleSearchUrl = `https://www.google.com/search?q=${encodedQuery}`;
    
    // Open in a new tab/window
    window.open(googleSearchUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleVerifyCompany}
      className="flex items-center gap-2 px-4 py-2 bg-orange-400 text-white rounded-md hover:bg-orange-600 transition-colors font-semibold text-sm shadow-md"
      title="Verify company on Google (location, images, and details)"
    >
      <FaGoogle className="w-4 h-4" />
      <span>Verify Company</span>
      <MdLocationPin className="w-4 h-4" />
    </button>
  );
}

export default VerifyCompanyButton;




// import { MdLocationPin } from "react-icons/md";
// import { FaGoogle } from "react-icons/fa";

// function VerifyCompanyButton({ companyName, address, location, localGovernment, city }) {
//   const handleVerifyCompany = () => {
//     const fullAddress = `${companyName} company ${address || location} ${localGovernment} ${city}`.trim();
//     const encodedQuery = encodeURIComponent(fullAddress);
//     const googleSearchUrl = `https://www.google.com/search?q=${encodedQuery}`;
//     window.open(googleSearchUrl, '_blank', 'noopener,noreferrer');
//   };

//   return (
//     <button
//       onClick={handleVerifyCompany}
//       className="flex items-center justify-center gap-2 px-3 py-2.5 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-all font-medium text-xs sm:text-sm shadow-md active:scale-95 w-full sm:w-auto"
//       title="Verify company on Google (location, images, and details)"
//     >
//       <FaGoogle className="w-4 h-4 flex-shrink-0" />
//       <span className="hidden sm:inline">Verify Company</span>
//       <span className="sm:hidden">Verify</span>
//       <MdLocationPin className="w-4 h-4 flex-shrink-0" />
//     </button>
//   );
// }

// export default VerifyCompanyButton;